import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CODE_CATALOG_URL } from '@app/pages/admin/developer-catalog-page/developer-catalog.utils';
import { isCodeCatalogEnabled } from '@app/utils/environment-features';

@Component({
  selector: 'app-orchestration-shell',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './orchestration-shell.html',
  styleUrl: './orchestration-shell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationShellComponent {
  readonly links = [
    { label: 'Overview', icon: 'pi pi-home', url: '/admin/orchestration' },
    { label: 'Instance fill', icon: 'pi pi-inbox', url: '/admin/orchestration/instance-fill' },
    { label: 'Processes', icon: 'pi pi-sitemap', url: '/admin/orchestration/processes' },
    { label: 'adminNotifications.title', icon: 'pi pi-bell', url: '/admin/orchestration/notifications' },
    { label: 'Assignments', icon: 'pi pi-list-check', url: '/admin/orchestration/assignments' },
    { label: 'Operation Monitoring', icon: 'pi pi-chart-line', url: '/admin/orchestration/monitoring' },
    { label: 'Storage', icon: 'pi pi-server', url: '/admin/orchestration/storage' },
    { label: 'HOST_LAYOUT_TITLE', icon: 'pi pi-box', url: '/admin/orchestration/host-layout' },
    { label: 'GEOSERVER_MONITOR_TITLE', icon: 'pi pi-map', url: '/admin/orchestration/geoserver' },
    { label: 'Subscriptions', icon: 'pi pi-calendar', url: '/admin/orchestration/subscriptions' },
    { label: 'Resource profiles', icon: 'pi pi-sliders-h', url: '/admin/orchestration/resources' },
    { label: 'Command configuration', icon: 'pi pi-cog', url: '/admin/orchestration/command-config' },
    { label: 'Code catalog', icon: 'pi pi-code', url: CODE_CATALOG_URL },
    { label: 'External service calls', icon: 'pi pi-globe', url: '/admin/orchestration/external-service-calls' },
    { label: 'SYSTEM_SETTINGS_TITLE', icon: 'pi pi-cog', url: '/admin/orchestration/settings' },
    { label: 'Access', icon: 'pi pi-lock', url: '/admin/orchestration/access' },
    { label: 'System logs', icon: 'pi pi-file', url: '/admin/logging' },
  ].filter(link => link.url !== CODE_CATALOG_URL || isCodeCatalogEnabled());
}
